import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

export default () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [step, setStep] = useState(() => {
    const param = searchParams.get('step');
    return param !== null ? Number(param) : 0;
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });  
  }, [step]);

  const onStepChange = (newStep) => {
    setStep(newStep);

    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set('step', newStep);

    setSearchParams(updatedParams);
  };

  return {
    step,
    onStepChange,
  };
};